(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (function () {
    var storageKey = 'xmill_cookie_choice_v1';
    var banner = document.querySelector('[data-cookie-banner]');
    var modal = document.querySelector('[data-cookie-modal]');
    var analyticsInput = document.querySelector('[data-consent-analytics]');
    var marketingInput = document.querySelector('[data-consent-marketing]');
    var preferencesInput = document.querySelector('[data-consent-preferences]');
    if (!banner || !modal) return;

    function readStoredChoice() {
      try { return JSON.parse(localStorage.getItem(storageKey)); } catch (error) { return null; }
    }

    function storeChoice(choice) {
      try { localStorage.setItem(storageKey, JSON.stringify(choice)); } catch (error) {}
    }

    function hideBanner() { banner.hidden = true; }
    function showBanner() { banner.hidden = false; }

    function nativeBannerPresent() {
      return Boolean(document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog, [class*="shopify-pc__banner"]'));
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function openModal(event) {
      if (event) event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }
      var nativeManageButton = document.querySelector('.shopify-pc__banner__btn-manage-prefs, [class*="shopify-pc__banner__btn-manage"]');
      if (nativeManageButton) {
        nativeManageButton.click();
        return;
      }
      var current = readStoredChoice() || {};
      analyticsInput.checked = Boolean(current.analytics);
      marketingInput.checked = Boolean(current.marketing);
      preferencesInput.checked = Boolean(current.preferences);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () { analyticsInput.focus(); }, 0);
    }

    function applyConsent(choice) {
      storeChoice(choice);
      var complete = function () { hideBanner(); closeModal(); };
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(choice, complete);
      } else {
        complete();
      }
    }

    function essentialOnly() { applyConsent({ analytics: false, marketing: false, preferences: false }); }
    function acceptAll() { applyConsent({ analytics: true, marketing: true, preferences: true }); }
    function saveSelected() { applyConsent({ analytics: analyticsInput.checked, marketing: marketingInput.checked, preferences: preferencesInput.checked }); }

    document.querySelectorAll('[data-cookie-open], [data-cookie-settings]').forEach(function (button) { button.addEventListener('click', openModal); });
    document.querySelectorAll('[data-cookie-close]').forEach(function (button) { button.addEventListener('click', closeModal); });
    document.querySelectorAll('[data-cookie-essential]').forEach(function (button) { button.addEventListener('click', essentialOnly); });
    document.querySelectorAll('[data-cookie-accept]').forEach(function (button) { button.addEventListener('click', acceptAll); });
    document.querySelectorAll('[data-cookie-save]').forEach(function (button) { button.addEventListener('click', saveSelected); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) closeModal(); });

    function initializeBanner() {
      if (nativeBannerPresent()) { hideBanner(); return; }
      var stored = readStoredChoice();
      if (stored) { hideBanner(); return; }
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
        if (window.Shopify.customerPrivacy.shouldShowBanner()) showBanner();
        return;
      }
      showBanner();
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { window.setTimeout(initializeBanner, 1000); });
    } else {
      window.setTimeout(initializeBanner, 1000);
    }
    window.setTimeout(function () { if (nativeBannerPresent()) hideBanner(); }, 2500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opportunities-packs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-packs-comparison]').forEach(function (section) {
    const translations = {
      en: { badge: 'Join the Xmill Community', title_a: 'What You Get When You Join the', title_b: 'Xmill Community', motto: 'Together, the AI is ours.', sub: 'When you join Xmill you are never on your own — real products every month, practical training, an active community and AI tools working for you. One monthly membership, no surprises.', included: "What's included", popular: 'Most Popular', permonth: '/mo', tag_top: 'Start with the essentials', tag_pro: 'Everything, for those who go all in', join: 'Join', refer: 'When two affiliates you brought in reach their first validated sales, you receive the value of your pack back.', king_h: 'KING Pack — for investors.', king_b: 'Everything in PRO, plus exclusive access to promotions and training with tokens.', foot: '* Videos, images and posts are created and published on social media through the Xmill Agents system.' },
      pt: { badge: 'Junta-te à comunidade XMill', title_a: 'O que recebes ao entrar na', title_b: 'comunidade XMill', motto: 'Juntos, a IA é nossa.', sub: 'Ao entrares na Xmill nunca estás sozinho — produtos reais todos os meses, formação prática, uma comunidade ativa e ferramentas de IA a trabalhar por ti. Uma adesão mensal, sem surpresas.', included: 'O que inclui', popular: 'Mais Popular', permonth: '/mês', tag_top: 'Começa com o essencial', tag_pro: 'Tudo, para quem entra a 100%', join: 'Aderir ao', refer: 'Quando dois afiliados que trouxeste atingirem as primeiras vendas validadas, recebes o valor do teu pacote de volta.', king_h: 'Pack KING — para investidores.', king_b: 'Junta tudo do PRO + acesso exclusivo a promoções e formações com tokens.', foot: '* Os vídeos, imagens e posts são criados e colocados nas redes sociais através do sistema Agents da Xmill.' }
    };
    const features = [
      ['Products of your choice every month', 'Produtos à tua escolha por mês', '2', '5'],
      ['Sales, AI, marketing & inside-sales courses', 'Cursos de vendas, IA, marketing e vendas internas', true, true],
      ['Access to the Xmill Community', 'Acesso à comunidade Xmill', true, true],
      ['Xmill support materials for the system', 'Material XMill de apoio ao sistema', true, true],
      ['Discount on product purchases', 'Desconto na compra de produtos', '10%', '15%'],
      ['Discount for new affiliates (first month)', 'Desconto novos afiliados (primeiro mês)', '20%', '35%'],
      ['Discount for affiliates on your team', 'Desconto afiliados da tua equipa', '10%', '15%'],
      ['Free social media videos — stories / animated GIFs *', 'Vídeos grátis p/ redes sociais — stories / GIF animado *', '1 / month', '4 / month'],
      ['Social media images — carousels / infographics *', 'Imagens p/ redes sociais — carrosséis / infográficos *', '1 / week', '4 / week'],
      ['Social media texts — posts / articles / quizzes *', 'Textos p/ redes sociais — posts / artigos / quizzes *', '3 / week', '10 / week'],
      ['Access to Xmill Marketplace & Xmill Life (school & community)', 'Acesso ao XMill Marketplace e Xmill Life (school & community)', true, true],
      ['Access to Xmill Life (PRO courses)', 'Acesso ao Xmill Life (cursos PRO)', false, true],
      ['Regular coaching and training', 'Acompanhamento e formação regular', true, true],
      ['One in-person training session per month', 'Uma formação presencial por mês', false, true],
      ['Priority access to Xmill franchising', 'Prioridade de acesso ao Xmill franchising', false, true],
      ['Online technical support', 'Apoio técnico online', true, true],
      ['Human technical support', 'Apoio técnico humano', false, true],
      ['Build your own community for your products or services', 'Cria a tua comunidade para os teus produtos ou serviços', false, true]
    ];
    const values = { '1 / month': ['1 / month', '1 / mês'], '4 / month': ['4 / month', '4 / mês'], '1 / week': ['1 / week', '1 / semana'], '4 / week': ['4 / week', '4 / semana'], '3 / week': ['3 / week', '3 / semana'], '10 / week': ['10 / week', '10 / semana'] };

    function valueMarkup(value, pro, lang) {
      if (value === true) return '<span class="xmp__check' + (pro ? ' xmp__check--gold' : '') + '" aria-label="Incluído">✔</span>';
      if (value === false) return '<span class="xmp__no" aria-label="Não incluído">✕</span>';
      const localized = values[value] ? values[value][lang === 'pt' ? 1 : 0] : value;
      return '<span class="xmp__value--' + (pro ? 'gold' : 'blue') + '">' + localized + '</span>';
    }

    function render(lang) {
      section.querySelector('[data-feature-rows]').innerHTML = features.map(function (feature, index) {
        return '<div class="xmp__row xmp__frow' + (index % 2 ? ' is-alt' : '') + '"><div class="xmp__feat">' + (lang === 'pt' ? feature[1] : feature[0]) + '</div><div class="xmp__cell">' + valueMarkup(feature[2], false, lang) + '</div><div class="xmp__cell xmp__pro">' + valueMarkup(feature[3], true, lang) + '</div></div>';
      }).join('');
      section.querySelectorAll('[data-t]').forEach(function (element) { element.textContent = translations[lang][element.dataset.t] || ''; });
      section.querySelectorAll('[data-lang]').forEach(function (button) { const active = button.dataset.lang === lang; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
    }

    section.querySelectorAll('[data-lang]').forEach(function (button) { button.addEventListener('click', function () { render(button.dataset.lang); }); });
    render('pt');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-packs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-promo-form]').forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      const button = event.submitter;
      const status = form.querySelector('[role="status"]');
      const originalLabel = button.textContent;
      button.disabled = true;
      status.textContent = '';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(form.elements.id.value),
              quantity: Number(form.elements.quantity.value)
            }]
          })
        });

        if (!response.ok) throw new Error('Não foi possível adicionar o pack.');

        if (button.dataset.cartAction === 'checkout') {
          window.location.href = window.Shopify.routes.root + 'checkout';
          return;
        }

        status.textContent = 'Pack adicionado ao carrinho.';
        button.textContent = '✓ Adicionado';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
        if (button.dataset.cartAction === 'add') {
          window.setTimeout(function () { button.textContent = originalLabel; }, 2000);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
